var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResultUnknown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 5,
  stroke: "currentColor",
  strokeWidth: 2.29,
  strokeLinecap: "round",
  strokeDasharray: "0.25 4.2"
})));
export default SvgResultUnknown;